import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import HowItWorks from "@/components/landing/HowItWorks";
import ForShoppers from "@/components/landing/ForShoppers";
import ForRetailers from "@/components/landing/ForRetailers";
import Ecosystem from "@/components/landing/Ecosystem";
import Demo from "@/components/landing/Demo";
import Vision from "@/components/landing/Vision";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import PrivacyPage from "@/components/landing/PrivacyPage";
import ConsentBanner from "@/components/landing/ConsentBanner";

const LandingPage = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <Problem />
      <HowItWorks />
      <ForShoppers />
      <ForRetailers />
      <Ecosystem />
      <Demo />
      <Vision />
      <FinalCta />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-[var(--cream)] text-[var(--ink)]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
        <ConsentBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
